<template>
  <v-container
    data-test="creditors-info-page"
    grid-list-md
    pa-3
    pb-5
    style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 d-flex row justify-space-between align-center py-0 px-2>
        <v-switch
          data-test="show-inactive-switch"
          v-model="showInactive"
          @change="fetchCreditors()"
          label="Mostrar Desativados"
          class="mt-0 pt-0"
          hide-details
        ></v-switch>
      </v-flex>

      <!-- Tabela -->
      <v-flex xs12>
        <v-data-table
          data-test="creditors-table"
          hide-actions
          :headers="headers"
          :items="creditors"
          class="elevation-0 py-1 qj-creditor-table">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top dark>
              <template v-slot:activator="{ on }">
                <span v-if="props.header.text === 'Nome'" v-on="on"
                  >{{ props.header.text }} <br />Importação</span
                >
                <!-- <span v-else-if="props.header.text === 'Prioridade'" v-on="on">{{ props.header.text }} Multicredor <br>Localizado | Não Localizado</span> -->
                <span v-else v-on="on">{{ props.header.text }}</span>
              </template>
              <span v-if="props.header.text === 'Nome'"
                >{{ props.header.text }} <br />Importação</span
              >
              <!-- <span v-else-if="props.header.text === 'Prioridade'">{{ props.header.text }} Multicredor <br>Localizado | Não Localizado</span> -->

              <span v-else>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <!-- Body table -->
          <template v-slot:items="props">
            <td
              data-test="creditor-row"
              :class="props.item.active ? '' : 'text--disabled'">
              <div class="text-truncate" style="margin-top: 8px">
                <span
                  class="d-inline-block caption text-xs-left grey--text text--darken-1"
                >
                  #{{ props.item.creditor_id }} -
                </span>

                <span>&nbsp;{{ props.item.name }}</span>
              </div>
              <div class="data-sync-proposal">
                <span>{{ props.item.last_importation | formatDate }}</span>
                <span v-if="props.item.syncProposal_status_history">
                  <v-card
                    :color="colorSync(props.item.syncProposal_status_history) + ' lighten-4'"
                    :class="
                      'elevation-0 ' +
                      colorSync(props.item.syncProposal_status_history) +
                      '--text text--darken-4'
                    "
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      font-weight: 500;
                      margin-left: 5px;
                    ">
                    Sync
                  </v-card></span
                >
                <span v-if="props.item.syncProposal_status_history">
                  <v-card
                    :color="colorProposal(props.item.syncProposal_status_history) + ' lighten-4'"
                    :class="
                      'elevation-0 ' +
                      colorProposal(props.item.syncProposal_status_history) +
                      '--text text--darken-4'
                    "
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      font-weight: 500;
                      margin-left: 5px;
                    ">
                    Proposal
                  </v-card></span
                >
              </div>
            </td>
            <td :class="props.item.active ? '' : 'text--disabled'">
              {{ props.item.sms_gateway_pool ? props.item.sms_gateway_pool.name : '--' }}
            </td>
            <td class="text-xs-center">
              <v-btn
                small
                round
                depressed
                :class="`${
                  props.item.trees && totalTree(props.item.trees) ? 'green lighten-4 ma-0' : 'ma-0'
                }`"
                @click="openModal({ text: 'Árvores em operação', type: 'tree' }, props.item)"
                >{{ totalTree(props.item.trees) }}</v-btn
              >
            </td>
            <td class="text-xs-center">
              <v-btn
                small
                round
                depressed
                :class="`${
                  props.item && totalStimulus(props.item) ? 'pink lighten-4 ma-0' : 'ma-0'
                }`"
                @click="openModal({ text: 'Estímulos em operação', type: 'stimulus' }, props.item)"
                >{{ totalStimulus(props.item) }}</v-btn
              >
            </td>
            <td :class="['text-xs-center', props.item.active ? '' : 'text--disabled']">
              {{ props.item.forecast.reduce((p, c) => c.budget + p, 0) | numeral("$0,0.00") }}
            </td>
            <td :class="['text-xs-center', props.item.active ? '' : 'text--disabled']">
              <div
                style="text-align: center"
                :class="
                  setColor(
                    (props.item.cost ? props.item.cost : 0) /
                      props.item.forecast.reduce((p, c) => c.budget + p, 0)
                  )
                ">
                <span>{{ (props.item.cost ? props.item.cost : 0) | numeral("$0,0.00") }} </span>
              </div>
              <div
                style="text-align: center"
                :class="
                  setColor(
                    (props.item.cost ? props.item.cost : 0) /
                      props.item.forecast.reduce((p, c) => c.budget + p, 0)
                  )
                ">
                <span v-if="props.item.forecast.reduce((p, c) => c.budget + p, 0)">{{
                  ((props.item.cost ? props.item.cost : 0) /
                    props.item.forecast.reduce((p, c) => c.budget + p, 0))
                    | numeral("0.00%")
                }}</span>
              </div>
            </td>
            <td class="skips-icon">
              <v-icon
                color="yellow darken-2"
                class="center-icon"
                @click="openModalSkips(props.item.creditor_id)"
                >lock</v-icon
              >

              <v-tooltip v-if="props.item.skip_multicreditor == 0" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="center-alert" v-bind="attrs" v-on="on" :color="'yellow darken-2'">
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <span>Credor está fora do skip de multicredor</span>
              </v-tooltip>

              <v-icon v-else class="center-alert" :color="'white'">
                mdi-alert-circle-outline
              </v-icon>
            </td>
            <td>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_aborted_deal'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Deal Abortados" }}
                  </span>
                </template>
                <span>Deals Abortados</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_cellphone'] == false"
                    v-on="on"
                    class="pink lighten-4 pink--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Telefone" }}
                  </span>
                </template>
                <span>Excluido telefone</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_deal_campaign'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Campanhas" }}
                  </span>
                </template>
                <span>Incluido Campanhas</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_deal_tag'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Deal tags" }}
                  </span>
                </template>
                <span>Incluido deal tags</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_contact_tag'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Contact tags" }}
                  </span>
                </template>
                <span>Incluido contact tags</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_email'] == false"
                    v-on="on"
                    class="pink lighten-4 pink--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "E-mail" }}
                  </span>
                </template>
                <span>Excluido e-mail</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_push'] == false"
                    v-on="on"
                    class="pink lighten-4 pink--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Push" }}
                  </span>
                </template>
                <span>Excluido push</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_responsible'] == true"
                    v-on="on"
                    class="indigo lighten-4 indigo--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Responsável" }}
                  </span>
                </template>
                <span>Incluido responsável</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_ura'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "URA" }}
                  </span>
                </template>
                <span>Incluido URA</span>
              </v-tooltip>
              <v-tooltip top v-if="props.item.creditor_params[0]">
                <template v-slot:activator="{ on }">
                  <span
                    v-if="props.item.creditor_params[0]['include_whatsapp'] == true"
                    v-on="on"
                    class="teal lighten-4 teal--text text--darken-2"
                    style="
                      font-size: 11px;
                      line-height: 12px;
                      padding: 2px 4px 0px 4px;
                      border-radius: 4px;
                      font-weight: 500;
                      margin-top: auto;
                      margin-left: 4px;
                    ">
                    {{ "Whatsapp" }}
                  </span>
                </template>
                <span>Incluido whatsapp</span>
              </v-tooltip>
            </td>
            <td class="text-xs-center">
              <v-tooltip v-if="props.item.creditor_status_history" bottom>
                <template v-slot:activator="{ on }">
                  <v-card
                    v-on="on"
                    :color="color(props.item.creditor_status_history) + ' lighten-4'"
                    :class="
                      'elevation-0 ' +
                      color(props.item.creditor_status_history) +
                      '--text text--darken-4'
                    ">
                    <v-card-title primary-title class="pa-1" style="width: max-content">
                      <div
                        :class="
                          color(props.item.creditor_status_history) +
                          ' lighten-2 mr-1 pa-1 align-center justify-center'
                        "
                        style="width: 22px; height: 22px; display: flex; border-radius: 50%">
                        <v-progress-circular
                          :width="2"
                          :size="16"
                          v-if="icon(props.item.creditor_status_history) == 'loading'"
                          indeterminate
                          :color="
                            color(props.item.creditor_status_history) + ' darken-4'
                          "></v-progress-circular>
                        <v-icon
                          small
                          :color="color(props.item.creditor_status_history) + ' darken-4'"
                          v-else>
                          {{ icon(props.item.creditor_status_history) }}
                        </v-icon>
                      </div>
                      <p class="caption font-weight-medium">
                        {{ titleCreditorStatusHistory(props.item.creditor_status_history) }}:
                        <br />
                        {{
                          dia(props.item.creditor_status_history) +
                          " " +
                          hora(props.item.creditor_status_history)
                        }}
                      </p>
                    </v-card-title>
                  </v-card>
                </template>
                <span>{{ infoStatusHistory(props.item.creditor_status_history) }}</span>
              </v-tooltip>
              <v-progress-circular
                v-else
                :size="20"
                color="primary"
                indeterminate></v-progress-circular>
            </td>
            <td class="text-xs-center">
              {{ props.item.last_prepared_at | formatDateAgo }}
            </td>
            <td style="min-width: 72px;">
              <v-tooltip bottom v-if="canManageQuarentine">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="edit-creditor-btn"
                    flat
                    icon
                    variant="text"
                    v-on="on"
                    v-bind="attrs"
                    color="secondary"
                    @click="EditCreditor(props.item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar credor</span>
              </v-tooltip>
            </td>
          </template>
          <!-- Footer table -->
          <template v-slot:footer>
            <td colspan="2">
              <strong>Total de notificações:</strong>
            </td>
            <!-- <td class="text-xs-center">{{ totalTreeAnalyzable }}</td> -->
            <td class="text-xs-center">{{ totalTreeStimulate }}</td>
            <td class="text-xs-center">{{ total_stimulus }}</td>
            <td class="text-xs-center">
              {{ totalBudget | numeral("$0,0.00") }}
            </td>
            <td class="text-xs-center">
              {{ total("cost") | numeral("$0,0.00") }}
            </td>
            <td></td>
            <!-- <td class="text-xs-center">{{ 0 }}</td> -->
          </template>
          <!-- Loading/Sem dados -->
          <template v-slot:no-data>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"></v-progress-circular>
                <strong v-else class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhum credor encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>

      <v-btn
        v-if="canManageQuarentine"
        color="accent"
        fixed
        bottom
        right
        fab
        @click="goToNewCreditor"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog v-model="dialog" scrollable width="500">
      <v-card>
        <v-toolbar class="elevation-0">
          <v-toolbar-title>{{ title.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
          </v-toolbar-items> -->
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" style="max-height: 80vh">
          <v-list dense v-if="list.length">
            <template v-for="(item, index) in list">
              <v-list-tile :key="item.id" avatar ripple @click="goTo(item)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < list.length" :key="index * 9999"></v-divider>
            </template>
          </v-list>
          <div v-else class="my-5 d-flex justify-center grey--text text--darken-2">
            Não há dados para carregar.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG SKIPS -->
    <v-dialog v-model="skipDialog" scrollable width="500">
      <v-card>
        <v-toolbar class="elevation-0">
          <v-toolbar-title>Skips</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="skipDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" style="max-height: 80vh">
          <v-list class="pa-4">
            <template>
              <v-list-tile v-for="(time, key) in skipList">
                <v-list-tile-content class="skip-row">
                  <span class="tag-approach-type" :class="key">{{ key }}</span>
                  <div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                        ><v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="warning"
                          v-if="time.lock_by_creditor_id"
                          >mdi-alert</v-icon
                        ></template
                      ><span>Trava por credor.</span>
                    </v-tooltip>
                    {{ time.lock_hours }}H
                  </div>
                </v-list-tile-content>
                <br />
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//services
import creditorService from "@/services/creditor";
import forecastService from "@/services/forecast";
import stimulusService from "@/services/consolidation-tree/stimulus";
import creditorParamsService from "@/services/consolidation-tree/creditor-params";
import whatsappSendersService from "@/services/consolidation-tree/whatsapp-senders";
import treeService from "@/services/consolidation-tree/consolidation-tree";
import WhatsAppService from "@/services/whatsapp";

//components
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";

import {
  color,
  icon,
  dia,
  hora,
  titleCreditorStatusHistory,
  infoStatusHistory,
  infoSyncProposal,
  colorProposal,
  colorSync,
  setColor,
} from "./utils";

export default {
  components: {
    FlaggedIcon,
  },
  data: () => ({
    color,
    icon,
    dia,
    hora,
    titleCreditorStatusHistory,
    infoStatusHistory,
    infoSyncProposal,
    colorProposal,
    colorSync,
    setColor,

    dialog: false,
    skipDialog: false,

    loading: false,
    list: [],
    skipList: [],
    creditors: [],
    healthCheck: null,
    headers: [
      {
        text: "Nome",
        value: "id-last_importation",
        width: "15%",
        sortable: false,
      },
      {
        text: "Pool",
        value: "sms_gateway_pool.name",
        width: "8%",
        sortable: false,
      },
      {
        text: "Árvores em operação",
        value: "",
        align: "center",
        width: "7%",
        sortable: false,
      },
      {
        text: "Estímulos em operação",
        value: "",
        align: "center",
        width: "7%",
        sortable: false,
      },
      {
        text: "Orçamento",
        value: "",
        align: "center",
        width: "7%",
        sortable: false,
      },
      {
        text: "Custo atual",
        value: "",
        align: "center",
        width: "7%",
        sortable: false,
      },
      {
        text: "Skips",
        value: "",
        align: "center",
        width: "1%",
        sortable: false,
      },
      {
        text: "Parametrização",
        value: "",
        align: "center",
        width: "16%",
        sortable: false,
      },

      {
        text: "Consolidação",
        value: "",
        align: "center",
        width: "14%",
        sortable: false,
      },
      {
        text: "Último preparo",
        value: "last_prepared_at",
        align: "center",
        sortable: false,
        width: "7%",
      },
      {
        text: "",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
    title: {
      text: "",
      type: "",
    },
    interval: null,
    showInactive: false,
  }),
  async created() {
    await this.fetchCreditors();
    await this.getCreditorNotifications();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  computed: {
    canManageQuarentine() {
      return this.$checkRole('quarentine_admin');
    },
    totalTreeStimulate() {
      var total = 0;
      this.creditors.forEach(({ trees }) => {
        total += trees.filter((t) => t.status == "STIMULATE").length;
      });
      return total;
    },
    totalTreeAnalyzable() {
      var total = 0;
      this.creditors.forEach(({ trees }) => {
        total += trees.filter((t) => t.status == "ANALYZABLE").length;
      });
      return total;
    },
    total_stimulus() {
      var total = 0;

      this.creditors.forEach(({ trees, stimulus }) => {
        trees
          .filter((t) => t.status == "STIMULATE")
          .map((t) => t.id)
          .forEach((id) => {
            total += stimulus
              .filter((s) => s.debt_node.active)
              .filter((s) => s.debt_node.debt_base_id == id).length;
          });
      });

      return total;
    },
    totalBudget() {
      var total = 0;
      this.creditors.forEach(({ forecast }) => {
        total += forecast.reduce((p, c) => c.budget + p, 0);
      });
      return total;
    },
  },
  methods: {
    async fetchCreditors() {
      this.loading = true;
      this.creditors = [];
      this.senders = [];
      this.whatsappSenders = [];

      try {
        const [
          creditorParamsRes,
          treesRes,
          stimulusRes,
          forecastRes,
          whatsappSendersRes,
          sendersRes,
          creditorsRes,
        ] = await Promise.all([
          this.getCreditorParams(),
          this.getTree(),
          this.getStimulus(),
          this.getForecast(),
          this.getWhatsappSenders(),
          this.getSenders(),
          this.getCreditors(),
        ]);

        const creditorParams = creditorParamsRes.objects;
        const trees = treesRes.objects;
        const stimulus = stimulusRes.objects;
        const forecast = forecastRes.objects;
        const whatsappSenders = whatsappSendersRes.objects;
        const senders = sendersRes.objects;
        const creditors = creditorsRes.objects;

        function mapByCreditor(array) {
          const map = new Map();
          array.forEach((item) => {
            if (!map.has(item.creditor_id)) map.set(item.creditor_id, []);
            map.get(item.creditor_id).push(item);
          });
          return map;
        }

        const treesMap = mapByCreditor(trees);
        const forecastMap = mapByCreditor(forecast);
        const paramsMap = mapByCreditor(creditorParams);
        const whatsappMap = mapByCreditor(whatsappSenders);

        const stimulusMap = new Map();
        stimulus.forEach((s) => {
          const ids = [s.debt_node.debt_base_id, s.debt_node.dabt_base_id].filter(Boolean);
          ids.forEach((id) => {
            if (!stimulusMap.has(id)) stimulusMap.set(id, []);
            stimulusMap.get(id).push(s);
          });
        });

        creditors.forEach((creditor) => {
          creditor.trees = treesMap.get(creditor.creditor_id) || [];
          creditor.forecast = forecastMap.get(creditor.creditor_id) || [];
          creditor.creditor_params = paramsMap.get(creditor.creditor_id) || [];
          creditor.whatsapp_sender = whatsappMap.get(creditor.creditor_id) || [];
  
          creditor.stimulus = [];
          creditor.trees.forEach((tree) => {
            const relatedStimulus = stimulusMap.get(tree.id) || [];
            creditor.stimulus = creditor.stimulus.concat(relatedStimulus);
          });
        });
  
        this.creditors = creditors;
        this.senders = senders;
        this.whatsappSenders = whatsappSenders;
  
        this.getSyncProposals();
        this.getHealthCheck();
        const oneMinute = 1000 * 60;
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          this.getSyncProposals();
          this.getHealthCheck();
        }, oneMinute);
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: "Não foi possível carregar os credores",
        });
      } finally {
        this.loading = false;
      }
    },

    getCreditors(notifications = false) {
      const params = {
        negotiation: false,
        notifications,
        order: "id",
      }

      if (!this.showInactive) params.active = true

      return creditorService.list(params)
        .catch((err) => console.error(err));
    },

    getTree() {
      return treeService.listDebtBases();
    },

    getStimulus() {
      return stimulusService.active_operation();
    },

    getCreditorParams() {
      return creditorParamsService.listParams();
    },

    getWhatsappSenders() {
      return whatsappSendersService.listWhatsAppSenders();
    },

    getForecast() {
      var monthYear = new Date().toISOString().slice(0, 7).split("-");
      return forecastService.findTotalBudget(monthYear[1], monthYear[0]);
    },

    async getHealthCheck() {
      let today = new Date().toISOString().split("T")[0];
      try {
        const healthCheck = await creditorService.healthCheck(today);
        await this.creditors.forEach((creditor, index) => {
          let hc = healthCheck.find((healthCheck) => {
            return healthCheck.creditor_id == creditor.creditor_id;
          });
          this.$set(this.creditors[index], "creditor_status_history", hc);
        });
      } catch (e) {
        console.error(e);
      }
    },

    async getSyncProposals() {
      try {
        const syncProposals = await creditorService.syncProposals();
        await this.creditors.forEach((creditor, index) => {
          let sp = syncProposals.find((syncProposals) => {
            return syncProposals.creditor_id == creditor.creditor_id;
          });
          this.$set(this.creditors[index], "syncProposal_status_history", sp);
        });
      } catch (e) {
        console.error(e);
      }
    },

    async getSenders() {
      return WhatsAppService.getSenders();
    },

    total(type) {
      let total = 0;
      if (typeof this.creditors === "undefined") return total;
      this.creditors.forEach((item) => {
        total += item[type] ? item[type] : 0;
      });
      return total;
    },

    async getCreditorNotifications() {
      let creditors = await this.getCreditors(true);
      if (creditors.objects) {
        creditors.objects.forEach((el, i) => {
          this.creditors[i].cost = el.cost;
        });
      }
    },

    totalTree(trees, status = "STIMULATE") {
      // "ARCHIVED"
      // "ANALYZABLE"
      // "STIMULATE"
      return trees.filter((t) => t.status == status).length;
    },

    totalStimulus(row, status = "STIMULATE") {
      var total = 0;
      row.trees
        .filter((t) => t.status == status)
        .map((t) => t.id)
        .forEach((id) => {
          total += row.stimulus
            .filter((s) => s.debt_node.active && s.active_at)
            .filter((s) => s.debt_node.debt_base_id == id).length;
        });
      return total;
    },

    openModal(title, row, status = "STIMULATE") {
      this.title = title;
      if (title.type == "tree") {
        this.list = row.trees.filter((t) => t.status == status);
      } else {
        var list = [];
        row.trees
          .filter((t) => t.status == status)
          .map((t) => t.id)
          .forEach((id) => {
            list = list.concat(
              row.stimulus
                .filter((s) => s.debt_node.active && s.active_at)
                .filter((s) => s.debt_node.debt_base_id == id)
            );
          });
        this.list = list;
      }
      this.list.forEach((l) => (l.creditor_id = row.creditor_id));
      this.dialog = true;
    },

    openModalSkips(id) {
      const creditor = this.creditors.find((creditor) => creditor.creditor_id == id);
      if (!creditor || !creditor.redis_locks) return;

      this.skipList = creditor.redis_locks;
      delete this.skipList.WHATSAPP
      delete this.skipList.EMAIL

      this.skipDialog = true;
    },

    EditCreditor(creditor) {
      if (this.canManageQuarentine) this.$router.push('/creditors-manager/' + creditor.creditor_id);
    },

    goToNewCreditor() {
      if (this.canManageQuarentine) this.$router.push('/creditors-manager');
    },

    goTo(item) {
      let url = "/debt-tree/";
      if (this.title.type == "tree") {
        url += "view?creditor=" + item.creditor_id + "&baseId=" + item.id;
      } else {
        url += "stimulus?creditor=" + item.creditor_id + "&baseId=" + item.debt_node.debt_base_id;
      }

      this.$router.push(url);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-datatable tbody tr:hover {
  background-color: #f5f5f5 !important;
}
</style>

<style scoped lang="scss">
.edit-creditor-btn {
  display: none;
}

tr:hover .edit-creditor-btn {
  display: inline-block;
}
</style>

<style>
.data-sync-proposal {
  display: flex;
  flex-wrap: inside;
  margin-top: 8px;
}
.qj-creditor-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.text-orange {
  color: orange;
  font-weight: bold;
}
.text-red {
  color: red;
  font-weight: bold;
}

.skip-row {
  display: flex;
  flex-direction: row !important;
  justify-content: space-between !important;
  border-bottom: 1px rgba(151, 151, 151, 0.501) solid;
  padding: 7px 35px;
}

.skips-icon {
  display: flex;
}

.center-icon {
  margin: 0 auto;
  width: 100%;
}

.center-alert {
  margin: 0 auto;
  width: 100%;
}

.SMS {
  background-color: #3f51b5;
}

.SMS_FLASH {
  font-size: 9px;
  padding: 4px 2px;
  margin: 0 !important;
  background-color: #2e86c1;
}

.EMAIL {
  font-size: 12px !important;
  margin: 0 !important;
  background-color: orange;
}

.EMAIL_TEXT {
  font-size: 9px;
  padding: 4px 2px;
  margin: 0 !important;
  background-color: #e74c3c;
}

.PUSH {
  padding: 4px 3px;
  margin: 0 !important;
  background-color: teal;
}

.VOICE_MESSAGE {
  padding: 4px 3px;
  margin: 0 !important;
  background-color: purple;
}

.VOICE_CALL {
  background-color: goldenrod;
}

.CALL_PHONE {
  padding: 4px 3px;
  margin: 0 !important;
  background-color: #004d40;
}

.CALL_CELLPHONE {
  background-color: #007327;
}

.WHATSAPP {
  background-color: #535a11;
}
</style>
